import { createContext, useCallback, useContext, useMemo, useState } from 'react';

// Global auth modal state. Any page (or route guard) can call
// `openAuth(optionalRedirectPath)` to surface the login modal as an
// overlay on the current page — no homepage round-trip.
//
// `redirectTo` is stashed in localStorage under a key the AuthModal reads
// after successful login. If omitted, the user just stays on the current
// route (which is what we want when ProtectedRoute is the caller — the
// route auto-renders once auth flips to true).

const AuthModalContext = createContext({
  isOpen: false,
  openAuth: () => {},
  closeAuth: () => {},
});

export function AuthModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openAuth = useCallback((redirectTo) => {
    if (redirectTo) {
      try { localStorage.setItem('ikz_pending_redirect', redirectTo); } catch (_) {}
    }
    setIsOpen(true);
  }, []);

  const closeAuth = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ isOpen, openAuth, closeAuth }),
    [isOpen, openAuth, closeAuth]
  );

  return <AuthModalContext.Provider value={value}>{children}</AuthModalContext.Provider>;
}

export function useAuthModal() {
  return useContext(AuthModalContext);
}
